import { render, staticRenderFns } from "./PageSolvencyConsolidated.vue?vue&type=template&id=0320dce3"
import script from "./PageSolvencyConsolidated.vue?vue&type=script&lang=js"
export * from "./PageSolvencyConsolidated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports